var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row bg-white shadow py-5 px-3 mb-4" }, [
      _c("div", { staticClass: "col-11" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-2" }, [_c("b", [_vm._v("Rut")])]),
          _c("div", { staticClass: "col-9" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-4" }, [
                _c("b", [_vm._v("Nombre/Razón Social")])
              ]),
              _c("div", { staticClass: "col-5" }, [_c("b", [_vm._v("Giro")])]),
              _c("div", { staticClass: "col-3" }, [
                _c("b", [_vm._v("Dirección")])
              ])
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "col-1 text-center" }, [
        _c("b", [_vm._v("...")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }